import { render, staticRenderFns } from "./AxWhatsNewDialog.vue?vue&type=template&id=1bb3b008&"
import script from "./AxWhatsNewDialog.vue?vue&type=script&lang=ts&"
export * from "./AxWhatsNewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AxWhatsNewDialog.vue?vue&type=style&index=0&id=1bb3b008&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports